import React from 'react';
import Button from 'components/Button';
import styles from './index.module.scss';
import startCase from 'lodash/startCase';
import valueType from 'components/Details';
import cn from 'classnames';
import { t } from 'i18next';
import PropTypes from 'prop-types';

const InfoWindowContent = ({ position }) => {
  const data = position?.infoWindowData;
  return (
    <div>
      <div style={{ flex: 1 }}>
        {data &&
          Object.keys(data).map(key => {
            return (
              <div className={cn(styles.detailData)} key={`${key}${key}`}>
                {data[key] ? (
                  <div className={styles.key} key={key}>
                    {t(data[key].label) || t(startCase(key))}
                  </div>
                ) : null}
                {
                  <div key={data[key]} className={styles.value}>
                    {valueType(data[key])}
                  </div>
                }
              </div>
            );
          })}
        {
          <Button
            id={`btn-click-${position.pageName}`}
            size="m"
            text="Go To Details"
          />
        }
      </div>
    </div>
  );
};

InfoWindowContent.propTypes = {
  position: PropTypes.object,
};
export default InfoWindowContent;
